const deleteSessionType = 'DELETE_SESSION';
const createSessionType = 'CREATE_SESSION';

export {
  deleteSessionType,
  createSessionType,
}